function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5803 8.99878C13.3041 5.61617 8.76023 5.43377 9.85759 0.517379C9.93888 0.152588 9.55683 -0.129296 9.24795 0.06139C6.29726 1.8356 4.1757 5.39232 5.95586 10.0517C6.10218 10.4331 5.66323 10.7896 5.34622 10.5408C3.87494 9.40502 3.7205 7.77175 3.85055 6.60276C3.89932 6.17164 3.34658 5.96438 3.11085 6.32088C2.5581 7.18311 1.99723 8.57595 1.99723 10.6735C2.30612 15.3163 6.15095 16.7423 7.53281 16.9247C9.50806 17.1817 11.6459 16.8086 13.1822 15.3743C14.8729 13.7742 15.4907 11.2207 14.5803 8.99878ZM7.03697 13.169C8.20749 12.8788 8.809 12.0166 8.97157 11.2538C9.23982 10.0683 8.19123 8.90758 8.89842 7.03388C9.16666 8.58424 11.5565 9.55425 11.5565 11.2456C11.6215 13.3431 9.39426 15.1422 7.03697 13.169Z",
  fill: "red"
});

function SvgDestroyed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestroyed);
export default __webpack_public_path__ + "static/media/Destroyed.3da9d79e.svg";
export { ForwardRef as ReactComponent };